import api from './api';

// Helper function to check authentication
const checkAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required. Please sign in.');
  }
  return token;
};

// Get user profile (includes portfolio summary)
export const getUserProfile = async () => {
  try {
    checkAuth();
    
    const response = await api.get('/api/data_predator/profile/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch user profile', error);
    throw error;
  }
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  try {
    checkAuth();
    
    const response = await api.put('/api/data_predator/profile/', profileData);
    return response.data;
  } catch (error) {
    console.error('Failed to update user profile', error);
    throw error;
  }
};

// Update user basic info (first_name, last_name)
export const updateUserInfo = async (userData) => {
  try {
    checkAuth();
    
    const response = await api.patch('/api/data_predator/profile/', userData);
    return response.data;
  } catch (error) {
    console.error('Failed to update user info', error);
    throw error;
  }
};

// Get user profile stats
export const getUserProfileStats = async () => {
  try {
    checkAuth();
    
    const response = await api.get('/api/data_predator/profile/stats/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch user profile stats', error);
    throw error;
  }
};
